import Typography from 'components/generics/texts/Typography';
import TotalCashButtons from 'pages/profile/components/ProfileTabContent/Bank&Transfers/components/TotalCashSection/components/TotalCashButtons';
import TotalCashTitle from 'pages/profile/components/ProfileTabContent/Bank&Transfers/components/TotalCashSection/components/TotalCashTitle';
import ProfileSection from 'pages/profile/components/ProfileTabContent/components/ProfileSection';
import classes from './index.module.scss';

const TotalCashSection = () => {
  return (
    <ProfileSection
      title={'Total Cash'}
      withBottomLine
    >
      <TotalCashTitle className={classes.totalCash} />
      <Typography className={classes.totalCashDescription}>
        Value of all your account funds include available cash and processing
        transactions.
      </Typography>
      <TotalCashButtons />
    </ProfileSection>
  );
};

export default TotalCashSection;
